<template>
  <div class="booking-format-address" style="display:flex;flex-direction:row;">
    <el-form
      ref="myForm1"
      :disabled="!isEditing"
      label-width="150px"
      label-position="right"
      style="margin-right:15px;"
    >
      <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('Message.Shipper')">
        <cargo-company-select
          :method-params="{shipper:true,active:true}"
          :headers="[$t('Partners.englishName')]"
          :fields="['englishName']"
          tag-name="englishName"
          :default-value="form.shipperId||''"
          style="width:190px;"
          :class="importDifferenceField.shipperId ? 'red-border' : ''"
          @change="p=>{shipperAutoCompleteChange(p)}"
        />
      </el-form-item>
      <booking-shipper-format-address ref="shipperFormatAddress" :job="job" :country-list="countryList" :manifest-info="form" :is-sea-house-channel.sync="isSeaHouseChannel" :is-wse-channel.sync="isWseChannel" :is-ronge-tong.sync="isRongeTong" :is-editing="isEditing" :special-character-check="specialCharacterCheck" />
    </el-form>
    <el-form
      ref="myForm2"
      :disabled="!isEditing"
      label-width="150px"
      label-position="right"
      style="margin-right:15px"
    >
      <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('Message.Consignee')">
        <cargo-company-select
          :method-params="{consignee:true,active:true}"
          :headers="[$t('Partners.englishName')]"
          :fields="['englishName']"
          tag-name="englishName"
          :default-value="form.consigneeId||''"
          style="width:190px;"
          :class="importDifferenceField.consigneeId ? 'red-border' : ''"
          @change="p=>{consigneeAutoCompleteChange(p)}"
        />
      </el-form-item>
      <booking-consignee-format-address ref="consigneeFormatAddress" :job="job" :country-list="countryList" :manifest-info="form" :is-sea-house-channel.sync="isSeaHouseChannel" :is-wse-channel.sync="isWseChannel" :is-ronge-tong.sync="isRongeTong" :is-editing="isEditing" :special-character-check="specialCharacterCheck" />
    </el-form>
    <el-form
      ref="myForm3"
      :disabled="!isEditing"
      label-width="150px"
      label-position="right"
      style="margin-right:15px"
    >
      <el-form-item v-show="notSeaHouseChannelOrWseChannel" :label="$t('Message.Notify')">
        <cargo-company-select
          :method-params="{notify:true,active:true}"
          :headers="[$t('Partners.englishName')]"
          :fields="['englishName']"
          tag-name="englishName"
          :default-value="form.notifyId||''"
          style="width:190px;"
          :class="importDifferenceField.notifyId ? 'red-border' : ''"
          @change="p=>{notifyAutoCompleteChange(p)}"
        />
      </el-form-item>
      <booking-notify-format-address ref="notifyFormatAddress" :job="job" :country-list="countryList" :manifest-info="form" :is-sea-house-channel.sync="isSeaHouseChannel" :is-wse-channel.sync="isWseChannel" :is-ronge-tong.sync="isRongeTong" :is-editing="isEditing" :special-character-check="specialCharacterCheck" />
    </el-form>
    <el-form v-if="isAddSpelling" label-width="100px" label-position="right">
      <el-form-item class="label-none custom">
        <cargo-ag-grid
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="finalRowData"
          style="width:224px;height:200px"
          @gridReady="params=>{gridApi=params.api}"
        />
        <div style="padding:5px 0">
          <div style="float:right">
            <el-button type="primary" :disabled="!isEditing" @click="add">{{ $t('Payment.new') }}</el-button>
            <el-button :disabled="!(isEditing && finalRowData.length > 1)" type="danger" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import bookingShipperFormatAddress from './bookingShipperFormatAddress'
import bookingConsigneeFormatAddress from './bookingConsigneeFormatAddress'
import bookingNotifyFormatAddress from './bookingNotifyFormatAddress'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import { cacheName, cache } from '@/utils/cacheManager'
import { Company } from '@/class/model/mdm/Company'
import { ManifestInfo } from '@/class/model/booking/ManifestInfo'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { ThirdPartyMappingUtil } from '@/class/cargo/model/utils/ThirdPartyMappingUtil'
import { ensureExecuteSuccess, sleep } from '@/utils/commonUtil'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'

export default {
  name: 'BookingFormatAddress',
  components: { cargoAdvanceSelect, cargoCompanySelect, bookingShipperFormatAddress, bookingConsigneeFormatAddress, bookingNotifyFormatAddress },
  props: {
    job: { type: Object, default: () => {} },
    manifestInfo: { type: Object, required: true },
    manifestInfos: { type: Array, required: true },
    isEditing: { type: Boolean, required: true },
    isAddSpelling: { type: Boolean, default: false },
    isSeaHouseChannel: { type: Boolean, default: false },
    isWseChannel: { type: Boolean, default: false },
    isRongeTong: { type: Boolean, default: false },
    specialCharacterCheck: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      form: new ManifestInfo().fillDefaultValue().getData(),
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        singleClickEdit: true,
        rowHeight: 32,
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClicked,
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        }
      },
      rowData: [],
      gridApi: null,
      thirdPartyMappingUtil: null,
      countryList: []
    }
  },
  computed: {
    columnDefs() {
      return [
        {
          headerName: this.$t('SeaExport.SoNo'),
          colId: 'soNo',
          field: 'soNo',
          width: 200,
          cellEditor: 'CargoAgGridCommonInputEditor',
          editable: this.isEditing
        }
      ]
    },
    finalRowData() {
      return this.rowData.filter(p => !p.deleted)
    },
    notSeaHouseChannelOrWseChannel() {
      return !(this.isSeaHouseChannel || this.isWseChannel || this.isRongeTong)
    },
    importDifferenceField() {
      if (!this.job) return {}
      return this.job.differencePrePlanFields || {}
    }
  },
  watch: {
    manifestInfo(newVal) {
      this.form = newVal
    },
    form(newVal) {
      this.$emit('update:manifestInfo', newVal)
    },
    manifestInfos(newVal) {
      this.rowData = newVal
    },
    rowData(newVal) {
      this.$emit('update:manifestInfos', newVal)
    },
    'manifestInfo.portOfLoading': {
      handler(val) {
        this.initCountryList()
      },
      deep: true
    },
    'job.uuid'() {
      this.$refs['myForm1'].clearValidate()
      this.$refs['myForm2'].clearValidate()
      this.$refs['myForm3'].clearValidate()
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    if (this.manifestInfos && this.manifestInfos.length > 0) {
      this.rowData = this.manifestInfos
    }
    await this.init()
  },
  methods: {
    async init() {
      await this.initCountryList()
    },
    async initCountryList() {
      if (this.isSeaHouseChannel) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('seaHouse')
      } else if (this.isWseChannel) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('wse')
      } else if (this.isRongeTong) {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('rongeTong')
      } else {
        this.thirdPartyMappingUtil = await ThirdPartyMappingUtil.getInstance('wse')
      }
      this.countryList = this.thirdPartyMappingUtil.getListByDataType('country')
    },
    async shipperAutoCompleteChange(data) {
      const manifestAddress = await new Company(data).getMainfestAddress()
      if (!manifestAddress) {
        return
      }
      this.form.shipperId = data.value
      this.form.shipperShortCode = manifestAddress.shortCode
      this.form.shipperEnterpriseCode = manifestAddress.enterpriseCode
      this.form.shipperEnterpriseName = manifestAddress.enterpriseName
      this.form.shipperAddress = manifestAddress.address
      this.form.shipperContactsType = manifestAddress.contactsType
      this.form.shipperContacts = manifestAddress.contacts
      this.form.shipperCityName = manifestAddress.cityName
      this.form.shipperProvinceCode = manifestAddress.provinceCode
      this.form.shipperProvinceName = manifestAddress.provinceName
      this.form.shipperZipCode = manifestAddress.zipCode
      this.form.shipperCountryCode = manifestAddress.countryCode
      this.form.shipperAeoEnterpriseCode = manifestAddress.aeoEnterpriseCode
    },
    async consigneeAutoCompleteChange(data) {
      const manifestAddress = await new Company(data).getMainfestAddress()
      if (!manifestAddress) {
        return
      }
      this.form.consigneeId = data.value
      this.form.consigneeShortCode = manifestAddress.shortCode
      this.form.consigneeEnterpriseCode = manifestAddress.enterpriseCode
      this.form.consigneeEnterpriseName = manifestAddress.enterpriseName
      this.form.consigneeAddress = manifestAddress.address
      this.form.consigneeContactsType = manifestAddress.contactsType
      this.form.consigneeContacts = manifestAddress.contacts
      this.form.consigneeCityName = manifestAddress.cityName
      this.form.consigneeProvinceCode = manifestAddress.provinceCode
      this.form.consigneeProvinceName = manifestAddress.provinceName
      this.form.consigneeZipCode = manifestAddress.zipCode
      this.form.consigneeCountryCode = manifestAddress.countryCode
      this.form.consigneeAeoEnterpriseCode = manifestAddress.aeoEnterpriseCode
    },
    async notifyAutoCompleteChange(data) {
      const manifestAddress = await new Company(data).getMainfestAddress()
      if (!manifestAddress) {
        return
      }
      this.form.notifyId = data.value
      this.form.notifyShortCode = manifestAddress.shortCode
      this.form.notifyEnterpriseCode = manifestAddress.enterpriseCode
      this.form.notifyEnterpriseName = manifestAddress.enterpriseName
      this.form.notifyAddress = manifestAddress.address
      this.form.notifyContactsType = manifestAddress.contactsType
      this.form.notifyContacts = manifestAddress.contacts
      this.form.notifyCityName = manifestAddress.cityName
      this.form.notifyProvinceCode = manifestAddress.provinceCode
      this.form.notifyProvinceName = manifestAddress.provinceName
      this.form.notifyZipCode = manifestAddress.zipCode
      this.form.notifyCountryCode = manifestAddress.countryCode
      this.form.notifyAeoEnterpriseCode = manifestAddress.aeoEnterpriseCode
    },
    add() {
      const newRow = new ManifestInfo().fillDefaultValue().getData()
      newRow.shipperCountryCode = 'CN'
      newRow.todo = 'new'
      this.rowData.push(newRow)
      setTimeout(() => {
        this.gridApi.setFocusedCell(this.finalRowData.length - 1)
        this.onRowClicked({ data: this.finalRowData[this.finalRowData.length - 1] })
      }, 100)
      // 清除错误提示
      this.changeAll()
      this.$emit('cleanUpAll')
    },
    onRowClicked(event) {
      if (!event.data) {
        return
      }
      this.form = event.data
      // 清除错误提示
      this.changeAll()
      this.$emit('cleanUpAll')
    },
    remove() {
      const cell = this.gridApi.getFocusedCell()
      const row = cell ? this.finalRowData[cell.rowIndex] : null
      if (row) {
        if (row.uuid) {
          row.deleted = true
          const tempRowData = this.rowData
          this.rowData = []
          this.$nextTick(() => {
            this.rowData = tempRowData
          })
        } else {
          const index = this.rowData.findIndex(p => p === row)
          if (index >= 0) {
            this.rowData.splice(index, 1)
          }
        }
        if (this.finalRowData.length > 0) {
          setTimeout(() => {
            this.gridApi.setFocusedCell(0)
            this.onRowClicked({ data: this.finalRowData[0] })
          }, 100)
        }
      }
    },
    checkModel(tabName) {
      if (this.isAddSpelling) {
        if (this.manifestInfos && this.manifestInfos.length > 0) {
          for (const item of this.manifestInfos) {
            if (!item.soNo) {
              throw new TabError(this.$t('SeaExport.CustomsNoCannotBeBlank'), tabName)
            }
          }
        }
      }
      this.$refs.shipperFormatAddress.checkModel(tabName)
      this.$refs.consigneeFormatAddress.checkModel(tabName)
      this.$refs.notifyFormatAddress.checkModel(tabName)
    },
    changeAll() {
      this.$refs.shipperFormatAddress.validate()
      this.$refs.consigneeFormatAddress.validate()
      this.$refs.notifyFormatAddress.validate()
    },
    changeTip(row) {
      if (row.includes('shipper')) {
        this.$refs.shipperFormatAddress.validate()
      }
      if (row.includes('consignee')) {
        this.$refs.consigneeFormatAddress.validate()
      }
      if (row.includes('notify')) {
        this.$refs.notifyFormatAddress.validate()
      }
    },
    toQuery(manifestInfos) {
      this.$nextTick(async() => {
        if (this.isAddSpelling) { // 加拼
          this.rowData = manifestInfos
          if (this.gridApi) {
            await sleep(100)
          } else {
            await ensureExecuteSuccess(() => this.gridApi)
          }
          let selectedNode = null
          if (this.gridApi) {
            const { rowsToDisplay } = this.gridApi.getModel()
            if (rowsToDisplay) {
              if (this.form && this.form.uuid) {
                selectedNode = rowsToDisplay.find(node => node.data.uuid === this.form.uuid) || rowsToDisplay[0]
              } else {
                selectedNode = rowsToDisplay[0]
              }
            }
          }
          const selectedData = selectedNode ? selectedNode.data : (this.finalRowData && this.finalRowData.length > 0 ? this.finalRowData[0] : null)
          if (selectedNode) {
            // 清除光标定位
            this.gridApi.clearFocusedCell()
            selectedNode.setSelected(true)
          }
          this.onRowClicked({ data: selectedData })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner {
    border: 1px solid red !important;
  }
}
</style>
